export default {"src":"/_next/static/media/storage.c9213d19.svg","height":33,"width":25};